<div class="dcp">
    @if(this.data.item?.action == 'confirmTenant') {
        <div class="header">
        <h2>You are about to move this prescription to {{data.item?.db_tenant == 'PL' ? 'Pillway' : (data.item?.db_tenant == 'SL' ? 'Sun Life' : ( data.item?.db_tenant == 'ML' ? 'Manulife' : 'the selected tenant') )}}. Do you want to continue?</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" [disabled]="isLoading" (click)="closeDialog()" mat-dialog-close>Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="confirmTransfer()">{{ isLoading ? "Confirming..." : "Confirm" }}</button>
        </div>
    </div> 
    } @else if(this.data.item?.action == 'transferToArchive') {
        <div class="header">
        <h2>Are you sure you want to move this fax to archive?</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" [disabled]="isLoading" (click)="closeDialog()" mat-dialog-close>Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="moveToArchive()">{{ isLoading ? "Moving..." : "Move" }}</button>
        </div>
    </div>
    } @else if(this.data.item?.action == 'transferToActive') {
        <div class="header">
        <h2>Are you sure you want to move this prescription to the active?</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" [disabled]="isLoading" (click)="closeDialog()" mat-dialog-close>Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="moveToArchive()">{{ isLoading ? "Activating..." : "Active" }}</button>
        </div>
    </div>
    } @else if(this.data.item?.action == 'updateStatus') {
        <div class="header">
        <h2>Are you sure you want to update the type of this prescription?</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" [disabled]="isLoading" (click)="closeDialog()" mat-dialog-close>Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="updateStatus()">{{ isLoading ? "Updating..." : "Update" }}</button>
        </div>
    </div>
    } @else if(this.data.item?.action == 'confirmRxId') {
    <div class="header">
        <h2>Would you like to add an RxID for this transfer prescription for {{data.item?.db_tenant == 'PL' ? 'Pillway' : (data.item?.db_tenant == 'SL' ? 'Sun Life' : ( data.item?.db_tenant == 'ML' ? 'Manulife' : 'the selected tenant') )}}.</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" [disabled]="isLoading" (click)="closeDialog()" mat-dialog-close>Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="confirmRxId()">{{ isLoading ? "Confirming..." : "Confirm" }}</button>
        </div>
    </div>
    } @else if(this.data.item?.action == 'mapDialougeFax') {
    <div class="header">
        <h2>You are about to move this eRx prescription to {{data.item?.db_tenant == 'PL' ? 'Pillway' : (data.item?.db_tenant == 'SL' ? 'Sun Life' : ( data.item?.db_tenant == 'ML' ? 'Manulife' : 'the selected tenant') )}}. Do you want to continue?</h2>
    </div>
    <div class="row">
        <div class="col-md-12 d-flex gap-2 justify-content-center">
            <button class="custom-btn" [disabled]="isLoading" (click)="closeDialog()" mat-dialog-close>Cancel</button>
            <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="mapDialougeFax()">{{ isLoading ? "Confirming..." : "Confirm" }}</button>
        </div>
    </div>
    }
</div>
